import StyledVoiceAssistantControlBar from '@webclient/components/voice-assistant-control-bar/styles';

export default function VoiceAssistantControlBar() {
  return (
    <StyledVoiceAssistantControlBar
      style={{ width: '64px' }}
      controls={{ leave: false }}
    />
  );
}
